import axios from "axios"
import SGHService from "src/services/SGHService"
import { sortProfessionals } from "./builders/professional"
import { sortSchedules } from "./builders/schedule"
import { sortSchedulesPatient } from "./builders/schedule"
import { sortSpecielties } from "./builders/specielties"
import { sortInsurences } from "./builders/medicalInsurences"
import { sortMedicalInsurance } from "./builders/medicalInsurencesbyprofessional"
import { sortLocais } from "./builders/locais"
import { sortindividuos } from "./builders/individuals"
import { sortcities } from "./builders/cities"
import { sortAppointmentTypes } from "./builders/appointmentTypes"

import { buttonsSchedulesPatient, applyHabilityButons } from "./builders/schedule"


import Notifier from "../../services/NotifyService"
import { env } from "../../config/env";
import { redirectToDigitalLogin } from "../../utils/safeRedirect";

export function fetchConvenios ({ getters, commit }, payload) {
  return new Promise((resolve, reject) => {
    SGHService.findConvenios(payload).then(response => {
      if (response.status == 204) {
        commit('setMedicalInsurances', null)
        return resolve()
      }
      const insurences = sortInsurences(response.data)
      commit('setMedicalInsurances', insurences)
      resolve()
    }).catch(e => {
      commit('setMedicalInsurances', null)
      reject(e)
    })
  })
}

export function fetchSpecialties ({ commit }, payload) {
  return new Promise((resolve, reject) => {
    SGHService.findSpecialty(payload)
      .then(response => {
        const specialties = sortSpecielties(response.data)
        commit('setSpecialties', specialties)
        resolve()
      }).catch(e => {
        commit('setSpecialties', null)
        reject(e)
      })

  })
}

export function findDatasAgendasCallCenter ({ commit }, payload) {
  return new Promise((resolve, reject) => {
    SGHService.findDatasCallCenter(payload)
      .then(response => {
        commit('setDatasAgenda', response.data.datas)
        resolve()
      }).catch(e => {
        commit('setDatasAgenda', null)
        reject(e)
      })
  })
}

export function findDatasAgendas({ commit }, payload) {
  return new Promise((resolve, reject) => {
    SGHService.findDatasAgendaProfessional(payload)
      .then(response => {
        commit('setDatasAgenda', response.data.datas)
        resolve()
      }).catch(e => {
        // Requisição cancelada por uma busca mais recente (troca de filtro):
        // não zera datasAgenda, quem deve prevalecer é a resposta em andamento.
        if (axios.isCancel(e)) {
          return resolve()
        }
        commit('setDatasAgenda', null)
        reject(e)
      })
  })
}

export function findAgendaProfissional ({ commit }, payload) {
  return new Promise((resolve, reject) => {
    SGHService.findAgendaProfessional(payload)
      .then(response => {
        commit('setProfissionaisAgenda', response.data)
        resolve()
      }).catch(e => {
        commit('setProfissionaisAgenda', null)
        reject(e)
      })
  })
}

export function findAgendaProfissionalCallCenter ({ commit }, payload) {
  return new Promise((resolve, reject) => {
    SGHService.findAgendaProfessionalCallCenter(payload)
      .then(response => {
        commit('setProfissionaisAgenda', response.data)
        resolve()
      }).catch(e => {
        commit('setProfissionaisAgenda', null)
        reject(e)
      })
  })
}

export function findDatasAgendaProfessional ({ commit }, payload) {
  return new Promise((resolve, reject) => {
    SGHService.findDatasAgendaProfessional(payload)
      .then(response => {
        // commit('setProfissionaisAgenda', response.data)
        resolve()
      }).catch(e => {
        // commit('setProfissionaisAgenda', null)
        reject(e)
      })
  })
}

export function findAgendamentoSgh ({ commit }, payload) {
  return new Promise((resolve, reject) => {
    SGHService.findAgendamentos(payload)
      .then(response => {
        if (response.status == 204 || !response.data || !response.data.datasHorasAgendadas || response.data.datasHorasAgendadas.length === 0) {
          Notifier.info("Nenhum agendamento encontrado conforme os dados informados nos filtros de busca");
          commit('setAgendamentosSgh', [])
          resolve()
          return
        }
        var agendas = null;
        if(payload.cpfPaciente!=null && payload.cpfPaciente!=undefined && payload.cpfPaciente!=""){
          agendas = buttonsSchedulesPatient(response.data.datasHorasAgendadas)
        } else {
          agendas = applyHabilityButons(response.data.datasHorasAgendadas)
        }
        commit('setAgendamentosSgh', agendas)
        resolve()
      }).catch(e => {
        commit('setAgendamentosSgh', [])
        reject(e)
        SGHService.redirectLogin(e)
      })
  })
}

export function findProfissional ({ commit }, payload) {
  return new Promise((resolve, reject) => {
    SGHService.findProfissionais(payload)
      .then(response => {
        if(response.status == 200) {
          const profissionais = sortProfessionals(response.data.listSghProfissional)
          commit('setProfessionals', profissionais)
          resolve(response.data)
        }
        if(response.status == 204){
          commit('setProfessionals', null);
          resolve(response.data)
        }

      }).catch(e => {
        commit('setProfessionals', null)
        reject(e)
      })
  })
}


export function findProfissionalCallCenter ({ commit }, payload) {
  return new Promise((resolve, reject) => {
    SGHService.findProfissionaisCallCenter(payload, payload.cancelToken)
      .then(response => {
        if(response.status == 200) {
          const profissionais = sortProfessionals(response.data.listSghProfissional)
          commit('setProfessionals', profissionais)
          resolve(response.data)
        }
        if(response.status == 204){
          commit('setProfessionals', null);
          resolve(response.data)
        }

      }).catch(e => {
        commit('setProfessionals', null)
        reject(e)
      })
  })
}

export function findConvenioByProfissional ({ commit }, payload) {
  return new Promise((resolve, reject) => {
    SGHService.findConvenioByProfissionais(payload)
      .then(response => {
        const list = response.data?.listSghProfissional
        if (!list?.length) {
          commit('setMedicalInsurances', null)
          resolve(response.data)
          return
        }
        const insurances = sortMedicalInsurance(list[0].insurances ?? [])
        commit('setMedicalInsurances', insurances)
        resolve(response.data)
      }).catch(e => {
        commit('setMedicalInsurances', null)
        reject(e)
      })
  })
}

export function findConvenioByProfissionalCallCenter ({ commit }, payload) {
  return new Promise((resolve, reject) => {
    SGHService.findConvenioByProfissionaisCallCenter(payload)
      .then(response => {
        const list = response.data?.listSghProfissional
        if (!list?.length) {
          commit('setMedicalInsurances', null)
          resolve(response.data)
          return
        }
        const insurances = sortMedicalInsurance(list[0].insurances ?? [])
        commit('setMedicalInsurances', insurances)
        resolve(response.data)
      }).catch(e => {
        commit('setMedicalInsurances', null)
        reject(e)
      })
  })
}

export function findNomesAgendas ({ commit }, payload) {
  return new Promise((resolve, reject) => {
    SGHService.findAgendas(payload)
      .then(response => {
        if(response.status == 200) {
          const schedules = sortSchedulesPatient(response.data.listSghAgenda)
          commit('setSchedules', schedules)
          resolve(response.data)
        }
        if(response.status == 204){

          Notifier.info("Nenhuma agenda encontrada conforme os dados informados nos filtros de busca");
          commit('setSchedules', null);
          resolve(response.data)
        }

      }).catch(e => {
        commit('setSchedules', null)
        reject(e)
      })
  })
}

export function findNomesAgendasCallCenter ({ commit }, payload) {
  return new Promise((resolve, reject) => {
    SGHService.findAgendasCallCenter(payload)
    
      .then(response => {
        if(response.status == 200) {
          const schedules = sortSchedules(response.data.listSghAgenda)
          if (!schedules || schedules.length === 0) {
            Notifier.info("Nenhuma agenda encontrada conforme os dados informados nos filtros de busca");
          }
          commit('setSchedules', schedules)
          resolve(response.data)
        }
        if(response.status == 204){
          Notifier.info("Nenhuma agenda encontrada conforme os dados informados nos filtros de busca");
          commit('setSchedules', []);
          resolve(response.data)
        }

      }).catch(e => {
        commit('setSchedules', [])
        reject(e)
      })
  })
}

export function findNomesAdicionarAgendasCallCenter ({ commit }, payload) {
  return new Promise((resolve, reject) => {
    SGHService.findAgendasCallCenter(payload)

      .then(response => {
        if(response.status == 200) {
          const schedules = sortSchedules(response.data.listSghAgenda)
          if (!schedules || schedules.length === 0) {
            Notifier.info("Nenhuma agenda encontrada conforme os dados informados nos filtros de busca");
          }
          commit('setSchedulesToAddTime', schedules)
          resolve(response.data)
        }
        if(response.status == 204){
          Notifier.info("Nenhuma agenda encontrada conforme os dados informados nos filtros de busca");
          commit('setSchedulesToAddTime', []);
          resolve(response.data)
        }

      }).catch(e => {
        commit('setSchedulesToAddTime', [])
        reject(e)
      })
  })
}

export function findLocalidade ({ commit }, payload) {

  return new Promise((resolve, reject) => {
    SGHService.findLocalidade(payload)
      .then(response => {
        const locais = sortLocais(response.data)
        commit('setLocal', locais)
        resolve(response.data.sghLocations)
      }).catch(e => {
        commit('setLocal', null)
        reject(e)
      })
  })
}

export function findLocalidadeSGHDigital ({ commit }, payload) {

  return new Promise((resolve, reject) => {
    SGHService.findLocalidadeSGHDigital(payload)
      .then(response => {
        const locais = sortLocais(response.data)
        commit('setLocal', locais)
        resolve(response.data.sghLocations)
      }).catch(e => {
        commit('setLocal', null)
        reject(e)
      })
  })
}

export function fetchStatus ({ commit }, payload) {
  return new Promise((resolve, reject) => {
    SGHService.findStatus(payload)
      .then(response => {
        let status = []
        response.data.map(item => {
          status.push({'nome': item.nome,
                              'codigo': item.sghs[0].codigoStatusSgh,
                              'sgh': item.sghs[0].codigoSgh  })
        });
        commit('setStatus', status)
        resolve(status)
      }).catch(e => {
        commit('setStatus', null)
        reject(e)
      })
  })
}

export function fetchIndividuals ({ commit }, payload) {
  return new Promise((resolve, reject) => {
    SGHService.findIndividuals(payload, payload.cancelToken)
      .then(response => {
        if(response.data != "") {  
          const individuals = sortindividuos(response.data)
          commit('setIndividuals', individuals)
        } else {
          commit('setIndividuals', null)
        }
        resolve(response)
      }).catch(e => {
        commit('setIndividuals', null)
        reject(e)
        SGHService.redirectLogin(e)
      })
  })
}

export function fecthIndividualCPFSGH ({ commit}, payload) {
  return new Promise((resolve, reject) => {
    SGHService.findIndividualCPFSGH(payload)
    .then(response => {
      if(response.data != "") {
        commit('setIndividual', response.data)
      } else {
        commit('setIndividual', null)
      }
      resolve(response)
    }).catch( e => {
      commit('setIndividual', null)
      reject(e)
    })
  })
}
export function getLogo ({ commit }, cliente) {
  return new Promise((resolve, reject) => {
    SGHService.getLogo(cliente)
      .then(response => {
        commit('setLogo', response.data)
        resolve(response)
      }).catch(e => {
        commit('setLogo', null)
        reject(e)
      })
  })
}

export function getCpfObrigatorio ({ commit }, cliente) {
  return new Promise((resolve, reject) => {
    SGHService.getCpfObrigatorio(cliente)
      .then(response => {
        commit('setCpfObrigatorio', response.data)
        resolve(response)
      }).catch(e => {
        commit('setCpfObrigatorio', null)
        reject(e)
      })
  })
}

export function fetchLoginDigital4Health ({ commit }, payload) {
  return new Promise((resolve, reject) => {
    SGHService.loginDigital4Health(payload)
      .then(response => {
        //console.log('Login Digital4Health bem sucedido, resposta:', response.headers)
        commit('setUser', response.headers.usuario)
        commit('setUserCpfDigital', response.headers.username)
        commit('setPodeIncluirHorarioExtra', response.headers['pode-incluir-horario-extra'] === 'true')
      }).catch(e => {
        commit('setUser', null)
        commit('setUserCpfDigital', null)
        commit('setPodeIncluirHorarioExtra', false)
        reject(e)
        redirectToDigitalLogin()
      })
  })
}

export function fetchCities ({ commit }, payload) {
  return new Promise((resolve, reject) => {
    SGHService.findCities(payload)
      .then(response => {
        if(response.data != "") {  
          const cities = sortcities(response.data)
          commit('setCities', cities)
        } else {
          commit('setCities', [])
        }
        resolve(response)
      }).catch(e => {
        commit('setCities', [])
        reject(e)
        SGHService.redirectLogin(e)
      })
  })
}


export function clearStorage ({ commit }) {
  return new Promise((resolve, reject) => {
    commit('setAgendamentosSgh', [])
    commit('setDatasAgenda', [])
    commit('setProfissionaisAgenda', [])
  })
}

export function getTipoAgendamentoSgh({ commit }, cliente) {
    return new Promise((resolve, reject) => {
        SGHService.getTipoAgendamentoSgh(cliente)
            .then(response => {
                commit('setTipoAgendamentoSgh', response.data);
                resolve(response);
            }).catch(e => {
                commit('setTipoAgendamentoSgh', false);
                reject(e);
            });
    });
}

export function fetchAppointmentTypes({ commit }, payload) {
    return new Promise((resolve, reject) => {
        SGHService.getAppointmentTypes(payload)
            .then(response => {
                const sortedAppointmentTypes = sortAppointmentTypes(response.data);
                commit('setAppointmentTypes', sortedAppointmentTypes);
                resolve(response);
            }).catch(e => {
                commit('setAppointmentTypes', []);
                reject(e);
            });
    });
}
